<template>
    <div class="top-container"></div>
</template>
<script>
export default {
    name:"top",

}
</script>
<style>
.top-container{
    width:100%;
    height:100%;
    /* 记得改颜色 */
    background-image: linear-gradient(to right, #f0a8d6, var(--el-color-primary));
    
}
</style>
